import AssetType from 'state/enums/AssetType'

export type HomeTabPath =
    | 'auto-dealer-news'
    | 'dealer-news'
    | 'hnb-signup'
    | 'marine-dealer-news'
    | 'mower-dealer-news'
    | 'news'
    | 'rv-dealer-news'
    | 'tractor-dealer-news'
    | 'trailer-dealer-news'

export interface FramePath {
    icon?: string
    name: string
    path: HomeTabPath
}

export const ASSET_TYPE_TO_TAB_PATH: Record<AssetType, HomeTabPath> = {
    [AssetType.AUTOMOBILE]: 'auto-dealer-news',
    [AssetType.MARINE]: 'marine-dealer-news',
    [AssetType.POWERSPORTS_VEHICLE]: 'dealer-news',
    [AssetType.OUTDOOR_POWER_EQUIPMENT]: 'mower-dealer-news',
    [AssetType.RECREATIONAL_VEHICLE]: 'rv-dealer-news',
}
